"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProvisioned = void 0;
const isProvisioned = (device) => {
    return (device.supervisor_version != null &&
        device.supervisor_version.length > 0 &&
        device.last_connectivity_event != null);
};
exports.isProvisioned = isProvisioned;
